import { useEffect } from 'react';
import { getAuthApplications } from '@/api/auth.api';
import { getAuthSelector, updateApplications } from '@/redux/auth/auth.slice';
import { useAppDispatch, useAppSelector } from '@/redux/store.hook';

export default function useAuthApplications() {
  const { isLogin, accessToken, userData } = useAppSelector(getAuthSelector);
  const userId = userData?.id;
  const dispatch = useAppDispatch();

  useEffect(() => {
    // OTP 驗證後的註冊暫態尚未取得登入 token。
    if (!isLogin || !accessToken) return;

    let cancelled = false;
    let inFlight = false;
    let lastAttempt = -Infinity;
    const refresh = () => {
      if (cancelled || inFlight || Date.now() - lastAttempt < 30_000) return;
      inFlight = true;
      lastAttempt = Date.now();
      void getAuthApplications()
        .then((response) => {
          if (!cancelled && response.data.success !== false && Array.isArray(response.data.data?.available)) {
            dispatch(updateApplications(response.data.data));
          }
        })
        .catch(() => {
          // 失敗時保留現有清單，交由既有 API 錯誤處理；下次回到分頁可重試。
        })
        .finally(() => { inFlight = false; });
    };
    const refreshWhenVisible = () => {
      if (document.visibilityState === 'visible') refresh();
    };

    refresh();
    window.addEventListener('focus', refreshWhenVisible);
    document.addEventListener('visibilitychange', refreshWhenVisible);

    return () => {
      cancelled = true;
      window.removeEventListener('focus', refreshWhenVisible);
      document.removeEventListener('visibilitychange', refreshWhenVisible);
    };
  }, [isLogin, accessToken, userId, dispatch]);
}
